import type { RuntimeConfig } from 'nuxt/schema'

export function AtStaging(act: (config: RuntimeConfig) => void) {
  const config = useRuntimeConfig()

  if (config.public.environment === 'staging') {
    act(config)
  }
}
